import { useNavigate } from 'react-router-dom';
import { ClipboardCheck, Droplets, BookOpen, UtensilsCrossed } from 'lucide-react';
import { cn } from '@/lib/utils';

interface QuickActionsGridProps {
  checkinDone: boolean;
  protocolDoneToday: boolean;
  waterToday: number;
}

const QuickActionsGrid = ({ checkinDone, protocolDoneToday, waterToday }: QuickActionsGridProps) => {
  const navigate = useNavigate();

  // Determine which action to highlight
  const getHighlightKey = () => {
    if (!checkinDone) return 'checkin';
    if (waterToday < 4) return 'water';
    if (!protocolDoneToday) return 'protocol';
    return '';
  };

  const highlightKey = getHighlightKey();

  const actions = [
    { key: 'checkin', icon: ClipboardCheck, label: 'Hacer check-in', path: '/app/checkin' },
    { key: 'water', icon: Droplets, label: 'Registrar agua', path: '/app/checkin' },
    { key: 'protocol', icon: BookOpen, label: 'Ver protocolo', path: '/app/protocolo' },
    { key: 'recipes', icon: UtensilsCrossed, label: 'Ver recetas', path: '/app/receitas' },
  ];

  return (
    <div>
      <h2 className="text-sm font-medium mb-3">Acciones rápidas</h2>
      <div className="grid grid-cols-2 gap-3">
        {actions.map((action) => {
          const isHighlighted = action.key === highlightKey;
          return (
            <button
              key={action.key}
              onClick={() => navigate(action.path)}
              className={cn(
                'flex items-center gap-3 bg-card rounded-xl p-4 shadow-card hover:shadow-soft transition-all text-left relative',
                isHighlighted && 'border-2 border-primary/30 shadow-primary/5'
              )}
            >
              {isHighlighted && (
                <div className="absolute top-2 right-2 w-2 h-2 rounded-full bg-primary animate-pulse-subtle" />
              )}
              <action.icon
                className={cn(
                  'h-5 w-5 flex-shrink-0',
                  isHighlighted ? 'text-primary' : 'text-primary/70'
                )}
              />
              <span className="text-sm font-medium">{action.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActionsGrid;
